<!-- 积分扣减规则 -->
<template>
  <div class="deduction_rules global-content-flex">
    <div class="global-felx">
      <div class="box">
      <y-title label="基础扣减规则"></y-title>
      <div class="box_content">
        <div class="box_line">
          <div>
            <el-radio v-model="baseScoresDeductRule" :label="1"
              ><span>不扣积分</span></el-radio
            >
          </div>
          <y-tip style="margin-left:20px;margin-top:12px" type="gley-empty" tipTitle="注：">发放基准积分后，会员再想进行退款时，不做基准积分扣除。</y-tip>
        </div>
        <div class="box_line">
          <div>
            <el-radio v-model="baseScoresDeductRule" :label="2"
              >按退款比例扣积分规则</el-radio
            >
          </div>
          <y-tip style="margin-left:20px;margin-top:12px" type="gley-empty" tipTitle="注：">
            <div class="tip_line">
              1.计算退款金额占订单实付金额的比例，根据此比例扣除对应积分，积分是小数时向下取整。
            </div>
            <div class="tip_line">
              2. 如果会员分多次退款，最终全部退完，那将扣除全部基准积分。
            </div>
            <div class="tip_line">3. 如果会员可用积分不足时，仅扣减至0分。</div>
            <div class="box_example">
              <b>例子：</b
              >触发积分计算时，订单实付100元，发放了100积分，之后会员退款52.5元，则应扣积分52.5分，向下取整为52分。如果此时会员积分账户仅剩40分，则实际仅扣除40分。
            </div>
          </y-tip>
        </div>
      </div>
      </div>
      <div class="box">
        <y-title label="奖励积分退款扣积分规则"></y-title>
        <div class="box_content">
          <div class="box_line">
            <div>
              <el-radio v-model="rewardScoresDeductRule" :label="1"
                >不扣积分</el-radio
              >
            </div>
            <y-tip style="margin-left:20px;margin-top:12px" type="gley-empty" tipTitle="注：">
              发放奖励积分后，会员再想进行退款时，不做奖励积分扣除。
            </y-tip>
          </div>
          <div class="box_line">
            <div>
              <el-radio v-model="rewardScoresDeductRule" :label="2"
                >按退款比例扣积分规则</el-radio
              >
            </div>
            <y-tip style="margin-left:20px;margin-top:12px" type="gley-empty" tipTitle="注：">
              <div class="tip_line">
                1.计算退款金额占订单实付金额的比例，根据此比例扣除对应积分，积分是小数时向下取整。
              </div>
              <div class="tip_line">
                2. 如果会员分多次退款，最终全部退完，那将扣除全部基准积分。
              </div>
              <div class="tip_line">3. 如果会员可用积分不足时，仅扣减至0分。</div>
              <div class="box_example">
                <b>例子：</b
                >触发积分计算时，订单实付100元，发放了100积分，之后会员退款52.5元，则应扣积分52.5分，向下取整为52分。如果此时会员积分账户仅剩40分，则实际仅扣除40分。
              </div>
            </y-tip>
          </div>
          <div class="box_line">
            <div>
              <el-radio v-model="rewardScoresDeductRule" :label="3"
                >扣除全部奖励积分</el-radio
              >
            </div>
            <y-tip style="margin-left:20px;margin-top:12px" type="gley-empty" tipTitle="注：">
              只要发生退款，不论是全部退款还是部分退款，均直接扣除全部奖励积分。
            </y-tip>
          </div>
        </div>
      </div>
    </div>
    <div class="global-bottom-btn">
      <y-button  type="blue" @click="save">保存</y-button>
    </div>
  </div>
</template>

<script>
import {
  RuleDeductDetail,
  RuleDeductSave,
} from "@/api/integralCenter/newMemberSystem";
export default {
  data() {
    return {
      baseScoresDeductRule: 1,
      rewardScoresDeductRule: 1,
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      RuleDeductDetail({
        cardId: this.$store.state.MemberSystemInfo.scoresCardId,
      }).then((res) => {
        this.baseScoresDeductRule = res.data.baseScoresDeductRule || 1;
        this.rewardScoresDeductRule = res.data.rewardScoresDeductRule || 1;
      });
    },
    save() {
      let obj = {
        baseScoresDeductRule: this.baseScoresDeductRule,
        rewardScoresDeductRule: this.rewardScoresDeductRule,
        scoresCardId: this.$store.state.MemberSystemInfo.scoresCardId,
      };
      RuleDeductSave(obj).then((res) => {
        this.$message.success("保存成功");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.deduction_rules{
  height: 100%;
}
.box {
  width: 95%;
  margin-top: 30px;
  color: #333333;
  &:nth-child(1) {
    margin-top: 0px;
  }

  .box_header {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    width:fit-content;
    background: linear-gradient(to right, #f4f4f4, transparent);
    height: 30px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    &::before {
      content: "";
      display: inline-block;
      width: 3px;
      height: 16px;
      background: #1f4287;
      margin-left: 12px;
      margin-right: 5px;
    }
  }
  .box_content {
    margin-top: 16px;
  }

  .box_line {
    // border-bottom: 1px dashed #d0d0d0;
    // padding: 10px 20px;
    margin-top: 16px;
    &:nth-child(1) {
      margin-top: 0px;
    }

    > div:nth-of-type(1) {
      height: 14px;
    }

    .box_line_tips {
      font-size: 12px;
      background: #f6f7fa;
      display: inline-block;
      border-radius: 6px;
      margin-left: 18px;
      padding: 10px;
      padding-right: 40px;

      .tip_head {
        img {
          position: relative;
          top: 2px;
          margin-right: 5px;
        }
      }

      .tip_line {
        margin-left: 19px;
        margin-top: 6px;
      }

      .box_example {
        margin-left: -8px;
        margin-top: 20px;
        text-indent: 2em;
        line-height: 20px;
      }
    }
  }

  .box_line:nth-last-of-type(1) {
    border-bottom: none;
  }
}
</style>